var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useState } from "react";
import { createUseStyles } from "react-jss";
import { EngageContext, ErrorType } from "../context";
import { EngageMessageType } from "engage-common/messages";
import TextField from "../components/TextField";
import Button from "../components/Button";
var useStyles = createUseStyles({
    admin: {
        height: "100%",
        backgroundColor: "#fafafa",
    },
    form: {
        padding: 10,
        display: "flex",
        alignItems: "center",
    },
    actionButton: {
        margin: 20,
        width: 200
    },
    input: {
        width: 250,
    },
    table: {
        textAlign: "left",
        width: "100%",
        backgroundColor: "white",
        borderCollapse: "collapse",
        boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
        "& td,th": {
            padding: 16,
            borderBottom: "1px solid rgba(224, 224, 224, 1)"
        },
        "& td": {
            fontWeight: 400
        },
        "& th": {
            fontWeight: 400
        }
    }
});
var AdminPage = function () {
    var _a = useContext(EngageContext), sendMessage = _a.sendMessage, clearError = _a.clearError, errorMap = _a.errorMap;
    var classes = useStyles();
    var _b = useState([]), lobbies = _b[0], setLobbies = _b[1];
    var handlePasswordInputChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setGetLobbiesFormValues(__assign(__assign({}, getLobbiesFormValues), (_a = {}, _a[name] = value, _a)));
        clearError(ErrorType.BadPassword);
    };
    var onGetLobbies = function (e) {
        e.preventDefault();
        sendMessage(__assign({ type: EngageMessageType.GetLobbyInfo }, getLobbiesFormValues), function (lobbies) {
            setLobbies(lobbies);
        });
    };
    var _c = useState({
        password: ""
    }), getLobbiesFormValues = _c[0], setGetLobbiesFormValues = _c[1];
    var getError = errorMap ? errorMap[ErrorType.BadPassword] : undefined;
    return (React.createElement("div", { className: classes.admin },
        React.createElement("form", { onSubmit: onGetLobbies, className: classes.form },
            React.createElement(TextField, { className: classes.input, labelText: "Password", name: "password", required: true, type: "password", errorText: getError, value: getLobbiesFormValues.password, onChange: handlePasswordInputChange }),
            React.createElement(Button, { color: "primary", className: classes.actionButton, type: "submit" }, "Get Lobbies")),
        React.createElement("table", { className: classes.table },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Title"),
                    React.createElement("th", null, "Host"),
                    React.createElement("th", null, "Created At"),
                    React.createElement("th", null, "Code"),
                    React.createElement("th", null, "Host Code"),
                    React.createElement("th", null, "Players Online"))),
            React.createElement("tbody", null, lobbies.map(function (lobby) {
                return React.createElement("tr", { key: lobby.id },
                    React.createElement("th", null, lobby.title),
                    React.createElement("td", null, lobby.hostName),
                    React.createElement("td", null, new Date(lobby.dateCreated).toLocaleString()),
                    React.createElement("td", null, lobby.id),
                    React.createElement("td", null, lobby.joinAsHostCode),
                    React.createElement("td", null, lobby.online));
            })))));
};
export default AdminPage;
//# sourceMappingURL=admin.js.map